module.exports = __webpack_public_path__ + "img/20200115160147824.b3767f3f.jpg";